import React from 'react';
import PropTypes from 'prop-types';

const BookIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={`fill-current ${className}`}
      fill="currentColor" // Ensures the color can be changed dynamically
       >
      <path d="M3.5 18V7C3.5 3 4.5 2 8.5 2H15.5C19.5 2 20.5 3 20.5 7V17C20.5 17.14 20.5 17.28 20.49 17.42" stroke="#CCAA60" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.35 15H20.5V18.5C20.5 20.43 18.93 22 17 22H7C5.07 22 3.5 20.43 3.5 18.5V17.85C3.5 16.28 4.78 15 6.35 15Z" stroke="#CCAA60" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 7H16" stroke="#CCAA60" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 10.5H13" stroke="#CCAA60" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

BookIcon.propTypes = {
  className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

BookIcon.defaultProps = {
  className: '', // Default to an empty string
};

export default BookIcon;